import { createFileRoute } from "@tanstack/react-router";
import { ObjectShowcase } from "@/pages/3d/ux/ObjectShowcase";

export const Route = createFileRoute("/demo/3d/ux/showcase")({
  component: RouteComponent,
});

function RouteComponent() {
  return <ObjectShowcase />;
}
